// 🔹 styles react-select réutilisables
export const selectCustomStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "white",   // Fond blanc
    zIndex: 1000,               // Devant tout
    boxShadow: "0 4px 10px rgba(0,0,0,0.15)", // Ombre légère
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#e9ecef" : "white", // Gris clair au survol
    color: "black",
  }),
  control: (provided) => ({
    ...provided,
    backgroundColor: "white",   // Fond du select
  }),
};
